import { Output, Input, ChangeDetectionStrategy, Component, EventEmitter, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { TreeViewComponent } from '@shared/tree-view/tree-view.component';
import { TaxonomyAttributeValue } from 'src/app/features/safety-recommendations/model/taxonomy-attribute-values-entity';

@Component({
  selector: 'app-attribute-values-tree-container',
  templateUrl: './attribute-values-tree-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,

})

export class AttributeValuesTreeContainerComponent {

  @ViewChild('treeV', { static: false }) treeV: TreeViewComponent;

  @Input() set attributeValuesTree(value: TaxonomyAttributeValue) {
    this.tree = this.generateTree(_.cloneDeep(value));
  }
  @Output() selectedElementChanged = new EventEmitter<any[]>();
  @Output() confirmSelection = new EventEmitter();

  tree = null;

  generateTree(data): any[] {
    const ID_KEY = 'identifier';
    const PARENT_KEY = 'parent';
    const CHILDREN_KEY = 'children';

    const tree = [];
    const childrenOf = {};
    let item;
    let id;
    let parentId;

    for (let i = 0, length = data.length; i < length; i++) {
      item = data[i];
      id = item[ID_KEY];
      parentId = item[PARENT_KEY] || 0;
      // every item may have children
      childrenOf[id] = childrenOf[id] || [];
      // init its children
      item[CHILDREN_KEY] = childrenOf[id];
      if (parentId !== 0) {
        // init its parent's children object
        childrenOf[parentId] = childrenOf[parentId] || [];
        // push it into its parent's children object
        childrenOf[parentId].push(item);
      } else {
        tree.push(item);
      }
    }

    return tree;
  }


}
